import { discountInfoSchema } from "./discountInfoSchema";
import { discountNotAvailableSchema } from "./discountNotAvailableSchema";
import { z } from "zod";

export const getProjectDiscountsPathParamsSchema = z.object({
  partnerId: z.coerce
    .string()
    .regex(/^[a-zA-Z0-9]+$/)
    .min(1)
    .max(20)
    .describe(
      "Identifier of the partner to query. iLOQ inc -partners have US-prefix in their partnerId.",
    ),
  projectCode: z.coerce
    .string()
    .regex(/^[0-9]+$/)
    .min(5)
    .max(5)
    .describe("Identifier of the project code to query."),
});

export type GetProjectDiscountsPathParams = z.infer<typeof getProjectDiscountsPathParamsSchema>;

/**
 * @description Contains all discounts related information for given partner & project code.
 */
export const getProjectDiscounts200Schema = z.lazy(() => discountInfoSchema);

export type GetProjectDiscounts200 = z.infer<typeof getProjectDiscounts200Schema>;

/**
 * @description 204 - Request was processed, but entity was not found.
 */
export const getProjectDiscounts204Schema = z.unknown();

export type GetProjectDiscounts204 = z.infer<typeof getProjectDiscounts204Schema>;

/**
 * @description 400 - Request could not be processed as parameters were invalid.
 */
export const getProjectDiscounts400Schema = z.unknown();

export type GetProjectDiscounts400 = z.infer<typeof getProjectDiscounts400Schema>;

/**
 * @description Discount was found, but it cannot be used for some reason. The reason is specified in response body.
 */
export const getProjectDiscounts404Schema = z.lazy(() => discountNotAvailableSchema);

export type GetProjectDiscounts404 = z.infer<typeof getProjectDiscounts404Schema>;

/**
 * @description 500 - Internal server error
 */
export const getProjectDiscounts500Schema = z.unknown();

export type GetProjectDiscounts500 = z.infer<typeof getProjectDiscounts500Schema>;

export const getProjectDiscountsQueryResponseSchema = z.union([
  z.lazy(() => getProjectDiscounts200Schema),
  z.lazy(() => getProjectDiscounts204Schema),
]);

export type GetProjectDiscountsQueryResponse = z.infer<
  typeof getProjectDiscountsQueryResponseSchema
>;
